import React from "react";
import styled from "styled-components";
// Components
import ProjectBox from "../Elements/ProjectBox";
import UnityDiagram from "../../assets/img/UnityDiagram.png";

export default function Objectives() {
  return (
    <Wrapper id="objectives">
      <div className="whiteBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">Objectives of ISRHB</h1>
            <p className="font13">
              Initiative for the Survival and Rights of Hindus in Bangladesh has
              been founded to fight for the existence of Hindus in Bangladesh.
              Using as a collaborative platform, the objecives of ISRHB are:
              <br />
              <ul>
                <li>
                  <b>Protect Life and Liberty: </b> Defend the Hindus in
                  Bangladesh from eventual and systematic ethnic cleansing
                  happening through violence, forced displacement, and religious
                  persecution.{" "}
                </li>
                <li>
                  <b>Legal Advocacy: </b> Provide legal assistance to victims of
                  discrimination, land grabbing, temple destruction, and
                  religious violence.
                </li>
                <li>
                  <b>International Awareness: </b> Engage global human rights
                  institutions, governments, and media to highlight the plight
                  of Bangladeshi Hindus.
                </li>
                <li>
                  <b>Cultural Preservation: </b> Safeguard Hindu temples,
                  festivals, traditions, and educational institutions under
                  threat.
                </li>
                <li>
                  <b>Data and Documentation: </b> Monitor, record, and publish
                  reports on incidents of violence, discrimination, and
                  demographic changes affecting Hindus.
                </li>
                <li>
                  <b>Humanitarian Relief: </b> Offer aid to affected families
                  and rebuild damaged homes, temples, and community centers.
                </li>
                <li>
                  <b>Empowerment & Education: </b> Promote community leadership,
                  legal awareness, and interfaith dialogue through workshops and
                  initiatives.
                </li>
              </ul>
            </p>
          </HeaderInfo>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  padding: 50px 0;
`;
const HeaderInfo = styled.div`
  margin-bottom: 50px;
  @media (max-width: 860px) {
    text-align: center;
  }
`;
const TablesWrapper = styled.div`
  @media (max-width: 860px) {
    flex-direction: column;
  }
`;
const TableBox = styled.div`
  width: 31%;
  @media (max-width: 860px) {
    width: 100%;
    max-width: 370px;
    margin: 0 auto;
  }
`;
